<ng-container  *ngIf="!loading">
  <div class="title text-primary bg-white p-4">{{ form.get("firstname")?.value + " " + form.get("lastname")?.value }}</div>
  <div class="d-flex gap-2 p-px-24" *ngIf="!loading">
      <div class="card-container p-px-40">
        <app-custom-dragdrop-image text1="" innerClass="border border-1 p-4 radius-full " [singleImage]="true" text2=""
                                   [smallInput]="true" text3="Ajouter une photo de profil" icon="/assets/icons/camera.svg"
                                   [forProfile]="true"
                                   (sendImage)="getImage($event)" [url]="[form.get('image')?.value]" width="190"
                                   height="190" [isDeletble]="true">
        </app-custom-dragdrop-image>
        <div class="text-center mt-px-24">
          <div class="fs-20">
            {{
              form.get("firstname")?.value + " " + form.get("lastname")?.value
            }}
          </div>
          <div class="fs-13 text-neutral-dark-grey">
            {{ form.get("mailadress")?.value }}
          </div>
        </div>
      </div>

      <div class="card-container w-100">
        <mat-tab-group mat-stretch-tabs="{{ false }}" mat-align-tabs="start" color="primary" [selectedIndex]="0">
          <mat-tab label="Compte">
            <div class="p-px-40">
              <div class="row my-2 align-items-end">
                <div class="col-3">
                  <app-custom-drop-down [parentForm]="form" controlName="civility" class="prefixe-class"
                                        [label]="'Civilité'" [options]="civilityForProfileOptions" [required]="true"
                                        [simpleDropDown]="true"></app-custom-drop-down>
                </div>
                <div class="col">
                  <app-custom-input [parentForm]="form" controlName="firstname" [label]="'Nom'"
                                    [required]="true"></app-custom-input>
                </div>
                <div class="col">
                  <app-custom-input [parentForm]="form" controlName="lastname" [label]="'Prénom'"
                                    [required]="true"></app-custom-input>
                </div>
              </div>
              <app-custom-input [parentForm]="form" controlName="mailadress" [label]="'Adresse mail'"
                                [required]="true"></app-custom-input>
              <div class="my-px-16"
                   [formGroup]="form">
                <mat-label>Date de naissance
                </mat-label>
                <input class="form-control py-px-12"
                       formControlName="birthDay"
                       placeholder="Sélectionner"
                       type="date"
                       [defaultValue]="form.get('birthDay')?.value"
                       [max]="maxDate"/>
              </div>
              <div class="row my-4">
                <app-custom-drop-down [parentForm]="form" controlName="worktype" [label]="'Domaine d’activité'"
                                      [options]="domaineOptions" [optionsDisplay]="domaineOptions"
                                      [simpleDropDown]="true"></app-custom-drop-down>
                <div class="text-muted">
                  Si vous êtes médecin ou chirurgien, choisissez le domaine Médecins
                </div>
              </div>
              <div class="row my-4">
                <app-custom-drop-down [parentForm]="form" controlName="fonction" [label]="'Fonction précise'"
                                      [optionsDisplay]="fonctionOptions" [options]="fonctionOptions"
                                      [simpleDropDown]="true"></app-custom-drop-down>
              </div>
              <div class="mt-px-16">
                <form #f="ngForm" [formGroup]="phoneForm">
                  <mat-label>Téléphone</mat-label>

                  <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="[CountryISO.France]"
                                      [enableAutoCountrySelect]="true"
                                      [enablePlaceholder]="true" [searchCountryFlag]="true"
                                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                      [selectFirstCountry]="false"
                                      [selectedCountryISO]="CountryISO.France"
                                      [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true"
                                      [maxLength]="phoneMaxLength"
                                      [inputId]="'numtel'" [(ngModel)]="phoneNumber"
                                      (ngModelChange)="onInputChange($event)" formControlName="phone">
                  </ngx-intl-tel-input>
                </form>
                <app-custom-input [label]="'Numéro SIRET'" [type]="'text'"
                                  [parentForm]="form" innerClass="mt-px-16"
                                  (input)="onSiretInputChange($event)"
                                  controlName="numsiret" [placeholder]="'0'"></app-custom-input>
                <span>Le SIRET est composé de 14 chiffres</span>
                <div class="row mt-px-16">
                  <div class="col-10">
                    <app-custom-input [label]="'Numéro de sécurité sociale'" [type]="'number'" [parentForm]="form"
                                      controlName="numsocialsecurity"
                                      (input)="onSecurityInputChange($event)"
                                      [placeholder]="'0'"></app-custom-input>
                    <span>Le numéro de sécurité sociale est composé de 13 chiffres</span>
                  </div>
                  <div class="col-2">
                    <app-custom-input [max]="2" [label]="'Clé'" [type]="'number'" [parentForm]="form" controlName="key"
                                      [placeholder]="'0'"
                                      (input)="onKeyInputChange($event)"
                                      ></app-custom-input>
                    <span>la clé est composé de 2 chiffres</span>
                  </div>
                </div>
                <app-custom-checkbox [formGroup]="form" controlName="ishandicap" class="mt-px-16" [label]="'Êtes-vous porteur(euse) d’un handicap ?'"></app-custom-checkbox>
                <app-custom-input *ngIf="form.get('ishandicap')?.value" label="Commentaire" innerClass="my-px-16"
                                  [parentForm]="form" controlName="handicapsituation"
                                  placeholder="Donnez nous plus d’informations sur l'handicap."
                                  type="textarea"></app-custom-input>
              </div>
              <div class="d-flex justify-content-end mt-px-100">
                <app-button color="primary" (handleClick)="submit()"
                            [disabled]="(form.invalid || phoneForm.invalid)" text="Sauvegarder les changements"
                            class="text-center" [innerClass]="'p-3 w-100'"></app-button>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Adresse">
            <div class="p-px-40">
              <div [formGroup]="formAddress">
                <div class="border border--1 rounded my-2">
                  <div class="px-4 py-2">
                    <div class="my-3 w-100">
                      <!-- <app-custom-input [label]="'Adresse du site'" [parentGroupName]="'{{$index}}'" [parentForm]="formAddress"  type="autocomplete" [options]="etablissementType" controlName="addressSite"  [required]="true" ></app-custom-input> -->
                      <mat-label>Adresse du domicile <span class="required">*</span></mat-label>
                      <input [required]="true" [defaultValue]="formAddress.get('adress')?.value" type="text" class="w-100"
                             formControlName="adress" (input)="autoCompleteOnChange($event.target)"
                             [matAutocomplete]="auto"/>
                      <mat-autocomplete #auto="matAutocomplete">
                        @if (addressLoading) {
                          <mat-option disabled>Recherche en cours…</mat-option>
                        } @else if (addressSearched && !addressList.length) {
                          <mat-option disabled>Aucune adresse trouvée</mat-option>
                        }
                        @for (option of addressList;track option) {
                          <mat-option [value]="getAdresseFormated(option)"
                                      (onSelectionChange)="addressSelected(option)">{{
                              getAdresseFormated(option)
                            }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      <div class="required" *ngIf="
                          formAddress.get('adress')?.touched &&
                          (formAddress?.get('adress')?.errors || formAddress?.get('postalcode')?.errors)
                        ">
                        Veuillez saisir une addresse valide de la liste (En France)
                      </div>
                    </div>
                    <div class="row my-3">
                      <div class="col-6 d-flex flex-column">
                        <mat-label>Pays <span class="required">*</span></mat-label>
                        <input [required]="true" [defaultValue]="formAddress.get('pays')?.value" type="text"
                               [formControlName]="'pays'"/>
                      </div>
                      <div class="col-6">
                        <mat-label>Code postal <span class="required">*</span></mat-label>
                        <input [required]="true" [defaultValue]="formAddress.get('postalCode')?.value" type="text"
                               [formControlName]="'postalCode'" class="w-100"/>
                      </div>
                    </div>
                    <div class="row my-3">
                      <div class="col-6 d-flex flex-column">
                        <mat-label>Ville <span class="required">*</span></mat-label>
                        <input [required]="true" [defaultValue]="formAddress.get('ville')?.value" type="text"
                               [formControlName]="'ville'"/>
                      </div>
                      <div class="col-6">
                        <mat-label>Département <span class="required">*</span></mat-label>
                        <input [required]="true" [defaultValue]="formAddress.get('departmentName')?.value" type="text"
                               [formControlName]="'departmentName'" class="w-100"/>
                      </div>
                    </div>
                    <div class="row my-3">
                      <div class="col-12">
                        <mat-label>Note</mat-label>
                        <input [placeholder]="'Autres précisions si besoins (Bâtiment, entrée, étage...)'"
                               [defaultValue]="formAddress.get('note')?.value" type="text" [formControlName]="'note'"
                               class="w-100"/>
                        <span>Champs limité à 50 charactères</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-px-100">
                <app-button color="primary" (handleClick)="submit()" text="Sauvegarder les changements"
                            class="text-center"
                            [disabled]="formAddress.invalid"
                            [innerClass]="'p-3 w-100'"></app-button>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Vos documents">
            <div class="p-px-40">
              <div>
                <app-text-separator text="identité"></app-text-separator>
                <div class="mt-px-16">
                  <app-custom-drop-down [parentForm]="form" controlName="nationality" class="prefixe-class"
                                        [label]="'Nationalité'" [withSearch]="false" [options]="nationalityOptions"
                                        [required]="false"
                                        [simpleDropDown]="true"></app-custom-drop-down>
                </div>
                @if (form.get('nationality')?.value == 'autre') {
                  <app-upload-file class="mt-px-16" label="Passeport" [files]="
                        this.candidatBody?.passport
                          ? [
                              {
                                file: this.candidatBody?.passport,
                                url: this.candidatBody?.passportUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'passport')" (deleteFile)="deleteFile($event, 'passport')"
                                   [required]="true"></app-upload-file>
                  <app-upload-file class="mt-px-16" label="Titre de séjour (Recto)" [files]="
                        this.candidatBody?.sejourFace
                          ? [
                              {
                                file: this.candidatBody?.sejourFace,
                                url: this.candidatBody?.sejourFaceUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'sejourFace')" (deleteFile)="deleteFile($event, 'sejourFace')"
                                   [required]="true"></app-upload-file>
                  <app-upload-file class="mt-px-16" label="Titre de séjour (Verso)" [files]="
                        this.candidatBody?.sejourBack
                          ? [
                              {
                                file: this.candidatBody?.sejourBack,
                                url: this.candidatBody?.sejourBackUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'sejourBack')" (deleteFile)="deleteFile($event, 'sejourBack')"
                                   [required]="true"></app-upload-file>
                } @else if (form.get('nationality')?.value == 'Française') {
                  @if (identityCart.get('value')?.value == 1) {
                    <div class="fs-13 fw-6 text-neutral-dark mb-px-4 pt-px-16">
                      Carte d’identité
                    </div>
                    <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
                                     (sendFile)="getFile($event, 'idFace')" class="mt-px-16" [required]="true"
                                     label="Pièce d’identité (Recto)"
                                     [files]="
                                          this.candidatBody?.idFace
                                            ? [
                                                {
                                                  file: this.candidatBody?.idFace,
                                                  url: this.candidatBody?.idFaceUrl
                                                }
                                              ]
                                            : []
                                        " (deleteFile)="deleteFile($event, 'idFace')"></app-upload-file>
                    <app-upload-file [parentForm]="identityCart" (sendFile)="getFile($event, 'idBack')" class="mt-px-16"
                                     label="Pièce d’identité (Verso)" (deleteFile)="deleteFile($event, 'idBack')"
                                     [files]="
                                          this.candidatBody?.idBack
                                            ? [
                                                {
                                                  file: this.candidatBody?.idBack,
                                                  url: this.candidatBody?.idBackUrl
                                                }
                                              ]
                                            : []
                                        " [required]="true"></app-upload-file>
                  } @else {
                    <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
                                     (sendFile)="getFile($event, 'passport')" class="mt-px-16" [files]="
                                          this.candidatBody?.passport
                                            ? [
                                                {
                                                  file: this.candidatBody?.passport,
                                                  url: this.candidatBody?.passportUrl
                                                }
                                              ]
                                            : []
                                        " label="Passeport" [required]="true"
                                     (deleteFile)="deleteFile($event, 'passport')"></app-upload-file>
                  }
                } @else {
                  @if (identityCart.get('value')?.value == 1) {
                    <div class="fs-13 fw-6 text-neutral-dark mb-px-4 pt-px-16">
                      Carte d’identité
                    </div>
                    <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
                                     (sendFile)="getFile($event, 'idFace')" class="mt-px-16" [required]="true"
                                     label="Pièce d’identité (Recto)"
                                     [files]="
                        this.candidatBody?.idFace
                          ? [
                              {
                                file: this.candidatBody?.idFace,
                                url: this.candidatBody?.idFaceUrl
                              }
                            ]
                          : []
                      " (deleteFile)="deleteFile($event, 'idFace')"></app-upload-file>
                    <app-upload-file [parentForm]="identityCart" (sendFile)="getFile($event, 'idBack')" class="mt-px-16"
                                     label="Pièce d’identité (Verso)" (deleteFile)="deleteFile($event, 'idBack')"
                                     [files]="
                        this.candidatBody?.idBack
                          ? [
                              {
                                file: this.candidatBody?.idBack,
                                url: this.candidatBody?.idBackUrl
                              }
                            ]
                          : []
                      " [required]="true"></app-upload-file>
                  } @else {
                    <app-upload-file [parentForm]="identityCart" [options]="identityCartOpt" [hasDropDown]="true"
                                     (sendFile)="getFile($event, 'passport')" class="mt-px-16" [files]="
                        this.candidatBody?.passport
                          ? [
                              {
                                file: this.candidatBody?.passport,
                                url: this.candidatBody?.passportUrl
                              }
                            ]
                          : []
                      " label="Passeport" [required]="true"
                                     (deleteFile)="deleteFile($event, 'passport')"></app-upload-file>
                  }
                }
                <app-text-separator text="RELEVE D’IDENTITE BANCAIRE" innerClass="mt-px-32"></app-text-separator>
                <app-upload-file class="mt-px-16" label="Relevé d’identité bancaire" [files]="
                        this.candidatBody?.bankDetails
                          ? [
                              {
                                file: this.candidatBody?.bankDetails,
                                url: this.candidatBody?.bankDetailsUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'bankDetails')"
                                 (deleteFile)="deleteFile($event, 'bankDetails')"></app-upload-file>
                <app-text-separator text="ASSURANCE MALADIE" innerClass="mt-px-32"></app-text-separator>
                <app-upload-file class="mt-px-16" label="Carte vitale ou attestation de sécurité sociale"
                                 (sendFile)="getFile($event, 'socialSecurityCertif')" [files]="
                        this.candidatBody?.socialSecurityCertif
                          ? [
                              {
                                file: this.candidatBody?.socialSecurityCertif,
                                url: this.candidatBody?.socialSecurityCertifUrl
                              }
                            ]
                          : []
                      " (deleteFile)="deleteFile($event, 'socialSecurityCertif')"></app-upload-file>
                <app-text-separator text="JUSTIFICATIF DE DOMICILE" innerClass="mt-px-32"></app-text-separator>
                @if (justificatifDomicile.get('value')?.value == 1) {

                  <app-upload-file class="mt-px-16" label="Pièce d'identité de la personne qui vous héberge"
                                   [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                   [secParentForm]="justificatifDomicile2"
                                   [hasDropDown]="true" [hasSecDropDown]="true" [required]="true" [files]="
                        this.candidatBody?.letterSignedByHost
                          ? [
                              {
                                file: this.candidatBody?.letterSignedByHost,
                                url: this.candidatBody?.letterSignedByHostUrl
                              }
                            ]
                          : []
                      " [options2]="justificatifDomicileOptn2" (sendFile)="getFile($event, 'letterSignedByHost')"
                                   (deleteFile)="deleteFile($event, 'letterSignedByHost')"></app-upload-file>
                  <app-upload-file class="mt-px-16"
                                   label="Lettre de l’hébergeant signée certifiant que vous habitez chez lui"
                                   [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                   [secParentForm]="justificatifDomicile2"
                                   [options2]="justificatifDomicileOptn2" [files]="
                        this.candidatBody?.justificatifDomicileHost
                          ? [
                              {
                                file: this.candidatBody?.justificatifDomicileHost,
                                url: this.candidatBody?.justificatifDomicileHostUrl
                              }
                            ]
                          : []
                      " [required]="true" (sendFile)="getFile($event, 'justificatifDomicileHost')"
                                   (deleteFile)="deleteFile($event, 'justificatifDomicileHost')"></app-upload-file>
                  <app-upload-file class="mt-px-16"
                                   label="Justificatif de domicile de moins d'un an au nom de l’hébergeant"
                                   [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                   [secParentForm]="justificatifDomicile2"
                                   [options2]="justificatifDomicileOptn2" [required]="true" [files]="
                        this.candidatBody?.justificatifDomicile
                          ? [
                              {
                                file: this.candidatBody?.justificatifDomicile,
                                url: this.candidatBody?.justificatifDomicileUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'justificatifDomicile')"
                                   (deleteFile)="deleteFile($event, 'justificatifDomicile')"></app-upload-file>
                } @else {
                  @if (justificatifDomicile2.get('value')?.value == 1) {
                    <app-upload-file class="mt-px-16" label="Facture de téléphone" [parentForm]="justificatifDomicile"
                                     [options]="justificatifDomicileOptn" [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true"
                                     [hasSecDropDown]="true" [required]="true" [files]="
                        this.candidatBody?.phoneBill
                          ? [
                              {
                                file: this.candidatBody?.phoneBill,
                                url: this.candidatBody?.phoneBillUrl
                              }
                            ]
                          : []
                      " [options2]="justificatifDomicileOptn2" (sendFile)="getFile($event, 'phoneBill')"
                                     (deleteFile)="deleteFile($event, 'phoneBill')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 2) {
                    <app-upload-file class="mt-px-16" label="Facture d'électricité ou de gaz"
                                     [parentForm]="justificatifDomicile"
                                     [options]="justificatifDomicileOptn" [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true"
                                     [required]="true" [hasSecDropDown]="true" [files]="
                        this.candidatBody?.electroBill
                          ? [
                              {
                                file: this.candidatBody?.electroBill,
                                url: this.candidatBody?.electroBillUrl
                              }
                            ]
                          : []
                      " [options2]="justificatifDomicileOptn2" (sendFile)="getFile($event, 'electroBill')"
                                     (deleteFile)="deleteFile($event, 'electroBill')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 3) {
                    <app-upload-file class="mt-px-16"
                                     label="Quittance de loyer émanant d'un organisme social ou d'une agence immobilière"
                                     [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                     [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true" [files]="
                        this.candidatBody?.quittanceImmob
                          ? [
                              {
                                file: this.candidatBody?.quittanceImmob,
                                url: this.candidatBody?.quittanceImmobUrl
                              }
                            ]
                          : []
                      " [hasSecDropDown]="true" [required]="true" [options2]="justificatifDomicileOptn2"
                                     (sendFile)="getFile($event, 'quittanceImmob')"
                                     (deleteFile)="deleteFile($event, 'quittanceImmob')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 4) {
                    <app-upload-file class="mt-px-16" label="Titre de propriété" [parentForm]="justificatifDomicile"
                                     [options]="justificatifDomicileOptn" [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true"
                                     [hasSecDropDown]="true" [required]="true" [options2]="justificatifDomicileOptn2"
                                     (sendFile)="getFile($event, 'propertyTitle')" [files]="
                        this.candidatBody?.propertyTitle
                          ? [
                              {
                                file: this.candidatBody?.propertyTitle,
                                url: this.candidatBody?.propertyTitleUrl
                              }
                            ]
                          : []
                      " (deleteFile)="deleteFile($event, 'propertyTitle')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 5) {
                    <app-upload-file class="mt-px-16" label="Facture d'eau" [parentForm]="justificatifDomicile"
                                     [options]="justificatifDomicileOptn" [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true"
                                     [required]="true" [files]="
                        this.candidatBody?.waterBill
                          ? [
                              {
                                file: this.candidatBody?.waterBill,
                                url: this.candidatBody?.waterBillUrl
                              }
                            ]
                          : []
                      " [hasSecDropDown]="true" [options2]="justificatifDomicileOptn2"
                                     (sendFile)="getFile($event, 'waterBill')"
                                     (deleteFile)="deleteFile($event, 'waterBill')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 6) {
                    <app-upload-file class="mt-px-16" label="Avis d’imposition ou certification de non imposition"
                                     [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                     [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true" [required]="true" [files]="
                        this.candidatBody?.certImpos
                          ? [
                              {
                                file: this.candidatBody?.certImpos,
                                url: this.candidatBody?.certImposUrl
                              }
                            ]
                          : []
                      " [hasSecDropDown]="true" [options2]="justificatifDomicileOptn2"
                                     (sendFile)="getFile($event, 'certImpos')"
                                     (deleteFile)="deleteFile($event, 'certImpos')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 7) {
                    <app-upload-file class="mt-px-16" label="Justificatif de taxe d’habitation ou de taxe foncière"
                                     [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn" [files]="
                        this.candidatBody?.taxBill
                          ? [
                              {
                                file: this.candidatBody?.taxBill,
                                url: this.candidatBody?.taxBillUrl
                              }
                            ]
                          : []
                      " [secParentForm]="justificatifDomicile2" [hasDropDown]="true" [hasSecDropDown]="true"
                                     [required]="true"
                                     [options2]="justificatifDomicileOptn2" (sendFile)="getFile($event, 'taxBill')"
                                     (deleteFile)="deleteFile($event, 'taxBill')"></app-upload-file>
                  }
                  @if (justificatifDomicile2.get('value')?.value == 8) {
                    <app-upload-file class="mt-px-16" label="Attestation ou facture d'assurance du logement"
                                     [parentForm]="justificatifDomicile" [options]="justificatifDomicileOptn"
                                     [secParentForm]="justificatifDomicile2"
                                     [hasDropDown]="true" [files]="
                        this.candidatBody?.assuranceLogement
                          ? [
                              {
                                file: this.candidatBody?.assuranceLogement,
                                url: this.candidatBody?.assuranceLogementUrl
                              }
                            ]
                          : []
                      " [hasSecDropDown]="true" [required]="true" [options2]="justificatifDomicileOptn2"
                                     (sendFile)="getFile($event, 'assuranceLogement')"
                                     (deleteFile)="deleteFile($event, 'assuranceLogement')"></app-upload-file>
                  }
                }
                <app-text-separator text="Carte grise de la véhicule" innerClass="mt-px-32"></app-text-separator>
                <app-upload-file class="mt-px-16" label="Carte grise de la véhicule" [files]="
                        this.candidatBody?.carteGrise
                          ? [
                              {
                                file: this.candidatBody?.carteGrise,
                                url: this.candidatBody?.carteGriseUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'carteGrise')"
                                 (deleteFile)="deleteFile($event, 'carteGrise')"></app-upload-file>
                <app-text-separator text="Assurances responsabilité professionnelle si vous en disposez"
                                    innerClass="mt-px-32"></app-text-separator>
                <app-upload-file class="mt-px-16" label="Assurances responsabilité professionnelle si vous en disposez"
                                 [files]="
                        this.candidatBody?.enrollmentCertificate
                          ? [
                              {
                                file: this.candidatBody?.enrollmentCertificate,
                                url: this.candidatBody?.enrollmentCertificateUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'enrollmentCertificate')"
                                 (deleteFile)="deleteFile($event, 'enrollmentCertificate')"></app-upload-file>
                <app-text-separator text="Profession" innerClass="mt-px-32"></app-text-separator>
                <app-upload-file class="mt-px-16" label="CV" [required]="true" [files]="
                        this.candidatBody?.cv
                          ? [
                              {
                                file: this.candidatBody?.cv,
                                url: this.candidatBody?.cvUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'cv')" (deleteFile)="deleteFile($event, 'cv')"></app-upload-file>
                <app-upload-file class="mt-px-16" label="Diplôme principal" [required]="true" [files]="
                        this.candidatBody?.firstDiplome
                          ? [
                              {
                                file: this.candidatBody?.firstDiplome,
                                url: this.candidatBody?.firstDiplomeUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'firstDiplome')"
                                 (deleteFile)="deleteFile($event, 'firstDiplome')"></app-upload-file>
                <!-- <app-upload-file
                        class="mt-px-16"
                        label="Autre Diplôme (Deuxième)"
                        [files]="
                          this.candidatBody?.secondDiplome
                            ? [
                                {
                                  file: this.candidatBody?.secondDiplome,
                                  url: this.candidatBody?.secondDiplomeUrl
                                }
                              ]
                            : []
                        "
                        (sendFile)="getFile($event, 'secondDiplome')"
                        (deleteFile)="deleteFile($event, 'secondDiplome')"
                        [required]="
                          form.get('worktype')?.value == 1 ||
                          form.get('worktype')?.value == 7 ||
                          form.get('worktype')?.value == 11
                        "
                      ></app-upload-file> -->
                <app-upload-file class="mt-px-16" label="Autre diplôme (Deuxième)" [files]="
                        this.candidatBody?.secondDiplome
                          ? [
                              {
                                file: this.candidatBody?.secondDiplome,
                                url: this.candidatBody?.secondDiplomeUrl
                              }
                            ]
                          : []
                      " (sendFile)="getFile($event, 'secondDiplome')"
                                 (deleteFile)="deleteFile($event, 'secondDiplome')"></app-upload-file>
                <app-upload-file class="mt-px-16" label="Autre diplôme (Troisième)"
                                 (sendFile)="getFile($event, 'thirdDiplome')"
                                 [files]="
                        this.candidatBody?.thirdDiplome
                          ? [
                              {
                                file: this.candidatBody?.thirdDiplome,
                                url: this.candidatBody?.thirdDiplomeUrl
                              }
                            ]
                          : []
                      " (deleteFile)="deleteFile($event, 'thirdDiplome')"></app-upload-file>
                <div class="my-px-16" [formGroup]="form">
                  <mat-label>Date de l’obtention du diplôme
                    <span class="required">*</span>
                  </mat-label>
                  <input class="form-control py-px-12" formControlName="graduationYear" placeholder="Sélectionner"
                         type="date"
                         [defaultValue]="form.get('graduationYear')?.value"/>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-px-100">
                <app-button color="primary" (handleClick)="submitDocument()" [disabled]="documentFormGroup.invalid"
                            text="Sauvegarder les changements" class="text-center"
                            [innerClass]="'p-3 w-100'"></app-button>
              </div>
            </div>
          </mat-tab>
          <!-- <mat-tab label="Mes filtres permanents">
            <div class="p-px-40">
              <div class="d-flex justify-content-between flex-wrap align-items-center">
                <div class="fs-20">Mes filtres permanents</div>
                <app-button color="primary" (handleClick)="submitFilter()" [disabled]="formPermanent.invalid"
                            text="Sauvegarder mes filtres" class="text-center" [innerClass]="'p-3 w-100'"></app-button>
              </div>
              <div class="fs-16 fw-4 text-muted my-4">
                Les filtres permanents seront appliqués automatiquement à toutes les
                futures offres de missions sélectionnées pour vous. Vous pouvez les
                modifier ou supprimer quand vous voulez.
              </div>
              <div class="mt-px-16">
                <app-custom-drop-down [parentForm]="formPermanent" class="prefixe-class" [label]="'Domaine d’activité'"
                                      controlName="worktype" [options]="domaineOptions" [required]="true"
                                      [simpleDropDown]="true"></app-custom-drop-down>
              </div>

              <div class="mt-px-16">
                <app-custom-drop-down [parentForm]="formPermanent" controlName="fonction"
                                      [label]="'Votre fonction précise'"
                                      class="prefixe-class" [options]="fonctionOptions" [required]="true"
                                      [simpleDropDown]="true"></app-custom-drop-down>
              </div>
              <div class="w-100 mt-2">
                <app-custom-drop-down [parentForm]="formPermanent" controlName="selectedDepartment"
                                      [label]="'Département'"
                                      class="prefixe-class" [options]="depatmentList" [required]="true"
                                      [simpleDropDown]="true"
                                      [multiple]="true"></app-custom-drop-down>
              </div>
              <div class="mt-px-16 d-flex flex-column">
                <mat-label>Date(s) de non-disponibilité</mat-label>
                <div class="inner-add-on right-add-on">
                  <input type="text" class="w-100" placeholder="Sélectionner" [defaultValue]="nonAvailabilityDates"
                         matInput
                         (click)="openAddDisponibility()"/>
                  <svg-icon class="inner-icon left" svgClass="placeholder-icon"
                            src="assets/icons/calender-check-primary.svg"></svg-icon>
                </div>
              </div>
            </div>
          </mat-tab> -->
        </mat-tab-group>
      </div>
  </div>
</ng-container>

<app-loader *ngIf="loading"></app-loader>
